// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"55772ded","241":"7b5974e3","245":"c218ebca","334":"09e91172","950":"04dccfc6"}[chunkId] + ".chunk.js";
};